import React from 'react';
import {PurchaseRequest} from '../../../models/PurchaseRequest';
import PropTypes from 'prop-types';
import {requestStores} from '../../ListOfPREditors.brick.jsx';
import {SaveSubmitBtn} from './SaveSubmitBtn.jsx';
import {DenyApproveBtn} from './DenyApproveBtn.jsx';
import {useProperty} from '@olympeio/core';
import {BrickContext} from 'olympe';
import {useFieldEditability} from '../utils/useFieldEditability.js';

/**
 * @param {Object} props
 * @return {JSX.Element|null}
 */
export function ActionButtons(props) {
    const useRequestStore = requestStores.get(props.prTag);

    const getStatus = useRequestStore((state) => state.getStatus);
    const {isDisabled} = useFieldEditability(props.prTag, {context: props.context});

    const currentTab = useProperty(props.context, 'Current tab', false);

    const status = getStatus();

    if (isDisabled('actions.saveSubmitBar')) {
        return null;
    }

    return (
        <>
            {(status === PurchaseRequest.statuses.pendingNbs && currentTab === PurchaseRequest.statuses.pendingNbs) ||
             (status === PurchaseRequest.statuses.pendingSB && currentTab === PurchaseRequest.statuses.pendingSB) ?
                <DenyApproveBtn
                    context={props.context}
                    prTag={props.prTag}
                    handleClickOnDeny={props.handleClickOnDeny}
                    handleClickOnApprove={props.handleClickOnApprove}
                    loading={props.loading}
                /> :
                <SaveSubmitBtn
                    context={props.context}
                    handleClickOnSave={props.handleClickOnSave}
                    handleClickOnSubmit={props.handleClickOnSubmit}
                    handleClickOnSubmitToRequester={props.handleClickOnSubmitToRequester}
                    handleClickOnWithdrawn={props.handleClickOnWithdrawn}
                    handleClickOnReject={props.handleClickOnReject}
                    loading={props.loading}
                    prTag={props.prTag}
                    disabledButtons={props.disabledButtons}
                    setDisabledButtons={props.setDisabledButtons}
                />}
        </>
    );
}

ActionButtons.propTypes = {
    prTag: PropTypes.string.isRequired,
    context: PropTypes.instanceOf(BrickContext).isRequired,
    handleClickOnDeny: PropTypes.func.isRequired,
    handleClickOnApprove: PropTypes.func.isRequired,
    handleClickOnSave: PropTypes.func.isRequired,
    handleClickOnSubmit: PropTypes.func.isRequired,
    handleClickOnSubmitToRequester: PropTypes.func.isRequired,
    handleClickOnWithdrawn: PropTypes.func.isRequired,
    handleClickOnReject: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    disabledButtons: PropTypes.object,
    setDisabledButtons: PropTypes.func,
};
